/*
 * Code generated by maegi. DO NOT EDIT.
 */

import type React from "react";

export const SocialMediaWordpress16 = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width={16} height={16} viewBox="0 0 16 16" {...props}>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M0 8c0-1.2.2-2.3.7-3.3l3.8 10.5C1.8 13.9 0 11.2 0 8m13.4-.4c0 .7-.3 1.5-.5 2.5l-.8 2.7-2.9-8.6c.5 0 .9-.1.9-.1.4-.1.3-.7-.1-.7 0 0-1.3.1-2.1.1s-2.1-.1-2.1-.1c-.5 0-.5.7-.1.7 0 0 .4.1.8.1l1.3 3.4L6 12.9 3.2 4.3c.5 0 .9-.1.9-.1.4-.1.3-.7-.1-.7 0 0-2.5.1-2.7.1C2.7 1.4 5.2 0 8 0c2.1 0 4 .8 5.4 2.1h-.1c-.7 0-1.3.7-1.3 1.4s.3 1.2.7 1.9c.3.5.7 1.2.7 2.2M8.1 8.7l2.5 6.7c.1 0 .1.1.1.1-.9.3-1.8.5-2.7.5-.8 0-1.5-.1-2.3-.3zM15 4.2c.6 1.1 1 2.4 1 3.8 0 2.9-1.6 5.5-4 6.9l2.5-7c.4-1.2.6-2.1.6-2.9 0-.3-.1-.5-.1-.8"
    />
  </svg>
);

export const __descriptor_SocialMediaWordpress = {
  name: "SocialMediaWordpress",
  instances: [{ size: 16, Component: SocialMediaWordpress16 }],
} as const;
